import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import React from 'react';

const DocumentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
      >
        <g id="Symbols">
          <g id="Icon-_x2F_-Cases-" transform="translate(-3.000000, -1.000000)">
            <path
              id="Shape"
              d="M22,4h-4.2c-0.4-1.2-1.5-2-2.8-2s-2.4,0.8-2.8,2H8C6.9,4,6,4.9,6,6v16c0,1.1,0.9,2,2,2h14
			c1.1,0,2-0.9,2-2V6C24,4.9,23.1,4,22,4L22,4z M19,18.5c0.6,0,1,0.4,1,1s-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1s0.4-1,1-1H19z M19,14.5
			c0.6,0,1,0.4,1,1s-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1s0.4-1,1-1H19z M19,10.5c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1h-8c-0.6,0-1-0.4-1-1
			c0-0.6,0.4-1,1-1H19z M15,4c0.6,0,1,0.4,1,1s-0.4,1-1,1s-1-0.4-1-1S14.4,4,15,4z M22,22H8V6h2v3h10V6h2V22L22,22z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default DocumentIcon;
